import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SchedulePlanMeeting from './schedulePlanMeeting';
import {
  getPocList,
  createMeeting,
  getMeetingById,
  updateMeeting,
  getInvoiceList
} from 'services/redux/brandActivtion/meetings/action';
import { getCorpPocList } from 'services/redux/brandActivtion/corporateClient/action';
import { getCorpClientList, getBaOpportunityFromLeadx } from 'services/redux/brandActivtion/corporateClient/action';
import { documentUploadUrl } from "services/redux/fileUpload/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
  pocList: state.baMeetingReducer.pocList,
  meetingById: state.baMeetingReducer.meetingById,
  corpClientList: state.CorpClientReducer.corpClientList,
  opportunityList: state.CorpClientReducer.opportunityList,
  corpClientPoc: state.CorpClientReducer.corpClientPoc,
  invoiceList: state.baMeetingReducer.invoiceList
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPocList,
      createMeeting,
      getMeetingById,
      updateMeeting,
      getCorpClientList,
      documentUploadUrl,
      getCorpPocList,
      getInvoiceList,
      documentUploadUrlPublic,
      getBaOpportunityFromLeadx
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SchedulePlanMeeting);
